module.exports = __webpack_public_path__ + "static/Alerta-00d8f1edd6b60bb2a37615254182e050.png";